import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Button } from 'ustore-ui';

import { CurrencyBRLPipe } from '../../pipes/currency-brl.pipe';
import { IconComponent } from '../icon/icon.component';
import { Icon } from '../../../core/models/icon.model';
import { I18nPipe } from '../../pipes/i18n.pipe';

export interface SidebarHeader {
  icon?: string;
  customIcon?: Icon;
  title: string;
  titleKey?: string;
  titleParams?: any;
}

@Component({
  selector: 'umkt-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    Button,
    CurrencyBRLPipe,
    IconComponent,
    I18nPipe
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() header!: SidebarHeader;
  @Input() isOpen = false;
  @Input() showCloseButton = true;
  @Input() showHeader = true;
  @Output() sidebarClose = new EventEmitter<void>();

  @Input() variant: 'default' | 'cart' = 'default'

  @Input() showTotal = false;
  @Input() totalLabel = 'Total';
  @Input() totalValue?: number;
  @Input() totalSuffix = '';
  @Input() showRegistryTotals = false;
  @Input() firstMonthTotal = 0;
  @Input() recurringTotal = 0; 

  @Input() showFooterButton = false;
  @Input() footerButtonText = '';
  @Input() footerButtonDisabled = false;

  @Output() footerButtonClick = new EventEmitter<void>();

  onFooterClick() {
    if (!this.footerButtonDisabled) this.footerButtonClick.emit();
  }

  onClose(): void {
    this.sidebarClose.emit();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: Event): void {
    if (this.isOpen) {
      this.onClose();
    }
  }
}
